import React, { useEffect } from "react";
import Form from "../components/Form";
import Cards from "../components/Cards";
import { useSelector, useDispatch } from "react-redux";
import { getMovies } from "../store/actions/movieAction";
import { Spinner } from "react-bootstrap";

const Movie = () => {
  const { movies: listFilm } = useSelector((state) => state.movieReducer);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getMovies());
  }, [dispatch]);

  const onSubmit = (input) => {
    dispatch(getMovies(input));
    // dispatch(getMoviesFromSearch(input));
  };
  return (
    <>
      <Form dataForm={(input) => onSubmit(input)}></Form>
      {listFilm.length < 1 && (
        <div>
          <Spinner animation="border" />
          <p>Loading</p>
        </div>
      )}
      {listFilm.length === 1 && <p>Film Not Found!</p>}
      {listFilm.length !== 1 && (
        <div className="container" style={{ marginTop: "25px" }}>
          <div className="row">
            {listFilm.map((film, idx) => {
              return <Cards key={idx} film={film}></Cards>;
            })}
          </div>
        </div>
      )}
    </>
  );
};

export default Movie;
